import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

document.onreadystatechange = function() {
	const preloader = document.getElementById('preloader');
	const state = document.readyState;
	const navBar = document.querySelector('.main-navigation');
	const header = document.querySelector('.tohi-logo');
	const hero = document.querySelector('.hero-section');
	const leftnav = document.querySelector('.menu-main-menu-container');
	const rightNav = document.querySelector('.menu-extra-menu-container');
	const tl = gsap.timeline();
	if (state === 'complete') {
		tl.to(
			preloader,
			2,
			{ backgroundColor: 'transparent',
				opacity: 0,
				zIndex: -1,
			}
		)
			.to(
				'header',
				0.3,
				{
					opacity: 1,
				},
				'=0.35'
			)
			.to(
				'.container',
				0.3,
				{
					opacity: 1,
				},
				'=0.35'
			)

			.to(
				[ '.container .center-section_claim', '.container .center-section_photo' ],
				0.3,
				{
					opacity: 1,
				},
				'=0.35'
			);
	}
};

document.addEventListener( 'DOMContentLoaded', () => {
	const projectsSection = document.querySelector('.container:nth-of-type(2)');
	projectsSection.setAttribute('id', 'scrollTo');
	// if (projectsSection) {
		
	// }
});
